module.exports = __webpack_public_path__ + "img/zabbix.ee1efd54.svg";